import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

// Modules Material utilises

// Autres modules externes utilises 

// Modules metiers utilises
import { ParcModule } from '../../structure/parc/parc.module';

// Modules communs utilises
import { BootstrapPopupModule } from '../../../shared/bootstrap-popup/bootstrap-popup.module';

// Composants metiers
import { UserPreferencesNotifications } from './components/user-preferences-notifications.component';

// Services metier
import { UserService } from './services/user.service';

// Bridges avec la partie angular
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,

		BootstrapPopupModule,
		
		ParcModule,
	],
	providers: [
		UserService,
	],
	declarations: [
		UserPreferencesNotifications,
	],
	exports: [
		UserPreferencesNotifications,
	]
})
export class UserModule {
	constructor() { }
}

// Initialisation des directives pour usage dans les templates angular-js
angular.module('auroraApp') //
	.directive('userPreferencesNotifications',
		downgradeComponent({ component: UserPreferencesNotifications })
	) //
;